import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from '@angular/router';
import { AuthenticationService } from '../services/api/methods/authentication.service';

@Injectable()
export class IsAdmin implements CanActivate {
  constructor(private router: Router, private authenticationService: AuthenticationService) {}

  public canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    console.log('IsAdmin', route);
    if (this.authenticationService.getUserType() === 'admin') {
      return true;
    } else {
      alert('Invalid user type');
      this.router.navigate(['/login']);
      return false;
    }
  }
}
